import { render, staticRenderFns } from "./dr-process-component.vue?vue&type=template&id=e5f9c5ca&scoped=true&"
import script from "./dr-process-component.vue?vue&type=script&lang=js&"
export * from "./dr-process-component.vue?vue&type=script&lang=js&"
import style0 from "./dr-process-component.vue?vue&type=style&index=0&id=e5f9c5ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f9c5ca",
  null
  
)

export default component.exports